import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'

import './styles.css'

// A single Watch History row: thumbnail (with resume-progress overlay), the
// artist + title, a progress label, and a resume/rewatch action. Kept separate
// from the shared CourseSummary so history-only affordances don't ripple across
// the site.
function HistoryItem({
  slug,
  title,
  teacher,
  teacherSlug,
  thumb,
  summary = '',
  progress = 0,
  completed = false
}) {
  const pct = Math.min(100, Math.max(0, Math.round(progress)))
  const watchPath = completed ? `/tutorials/${slug}` : `/tutorials/${slug}?watch=1`

  return (
    <div className="history-item">
      <Link
        to={watchPath}
        className="history-item__thumb"
        aria-label={completed ? `Rewatch ${title}` : `Resume ${title}`}
      >
        <img src={thumb} alt={title} />
        <span className="history-item__play" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="currentColor" d="M8 5v14l11-7z" />
          </svg>
        </span>
        {!completed && (
          <span className="history-item__bar" aria-hidden="true">
            <span
              className="history-item__bar-fill"
              style={{ width: `${pct}%` }}
            />
          </span>
        )}
      </Link>

      <div className="history-item__info">
        <Link to={`/artists/${teacherSlug}`} className="history-item__teacher">
          {teacher}
        </Link>
        <Link to={watchPath} className="history-item__title" title={title}>
          {title}
        </Link>
        {summary && <p className="history-item__summary">{summary}</p>}
        <span
          className={classnames('history-item__status', {
            'history-item__status--done': completed
          })}
        >
          {completed ? (
            <>
              <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M9.55 17.6 4.4 12.45l1.42-1.42 3.73 3.72 8.23-8.23 1.42 1.42z"
                />
              </svg>
              Completed
            </>
          ) : (
            `${pct}% watched`
          )}
        </span>
      </div>

      <div className="history-item__action">
        <Link
          to={watchPath}
          className={classnames('btn -mini', {
            '-blue-2': !completed,
            '-border-white': completed
          })}
        >
          {completed ? 'Rewatch' : 'Continue Watching'}
        </Link>
      </div>
    </div>
  )
}

HistoryItem.propTypes = {
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  teacher: PropTypes.string.isRequired,
  teacherSlug: PropTypes.string.isRequired,
  thumb: PropTypes.string.isRequired,
  summary: PropTypes.string,
  progress: PropTypes.number,
  completed: PropTypes.bool
}

export default HistoryItem
